var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXCircleGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1673C16.0627 20.1673 20.1667 16.0633 20.1667 11.0007C20.1667 5.93804 16.0627 1.83398 11 1.83398C5.93743 1.83398 1.83337 5.93804 1.83337 11.0007C1.83337 16.0633 5.93743 20.1673 11 20.1673Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3982 7.60247C14.7562 7.96045 14.7562 8.54085 14.3982 8.89883L8.89822 14.3988C8.54024 14.7568 7.95984 14.7568 7.60186 14.3988C7.24388 14.0409 7.24388 13.4605 7.60186 13.1025L13.1019 7.60247C13.4598 7.24449 14.0402 7.24449 14.3982 7.60247Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60186 7.60247C7.95984 7.24449 8.54024 7.24449 8.89822 7.60247L14.3982 13.1025C14.7562 13.4605 14.7562 14.0409 14.3982 14.3988C14.0402 14.7568 13.4598 14.7568 13.1019 14.3988L7.60186 8.89883C7.24388 8.54085 7.24388 7.96045 7.60186 7.60247Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleGray);
export default __webpack_public_path__ + "static/media/x-circle-gray.3c81da8cf3ed3115f849b443c1a4e088.svg";
export { ForwardRef as ReactComponent };